import React, { useCallback, useEffect, useState } from 'react';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import SelectDropdown from 'components/base/select-dropdown';
import { ConversionListType } from 'models/pricing.model';
import { ENUM_UNIT } from 'models/common.model';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { debounce } from 'utils/functions';
import { BaseMealItemType } from 'models/pricing.model';

type Props = {
  itemIndex: number;
  mix_id: string;
  type: 'items';
  meal: ConversionListType | undefined;
  handleInputChange: (
    itemIndex: number,
    value: string | number | ENUM_UNIT,
    name: keyof BaseMealItemType,
    type: 'items',
    ingredient?: ConversionListType
  ) => void;
};
const MealMixesSelect = ({ itemIndex, handleInputChange, meal, type }: Props) => {
  const [search, setSearch] = useState('');
  const [ingredients, setIngredients] = useState<ConversionListType[]>([]);
  const fetchIngredients = async (searchString: string) => {
    try {
      const response = await apiService.get(`ingredient-mix`, {
        version: 'v2',
        params: { size: '50', name: searchString, page: 1 }
      });
      if (response) {
        setIngredients(
          response?.data?.data?.map((_: ConversionListType) => ({
            ..._,
            name: _?.ingredient?.name
          }))
        );
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response?.data?.message || 'Error fetching excel meals'}
          type='error'
        />
      );
    } finally {
      // setSearch('');
    }
  };

  const debounceFetchIngredients = useCallback(debounce(fetchIngredients, 500), []);

  useEffect(() => {
    debounceFetchIngredients(search);
  }, [search]);
  return (
    <SelectDropdown
      hasSearch
      placeholder='Search Ingredients'
      value={meal?.ingredient?.name}
      setValue={(item) => {
        handleInputChange(itemIndex, item.id, 'mix_id', type, item);
      }}
      onChange={(val) => {
        setSearch(val);
      }}
      options={ingredients}
    />
  );
};
export default MealMixesSelect;
